import { isMobileGameDevice } from '../hooks/useMobileGameViewport';

export type MobileAtlas = { textures: Array<{image:string;animation?:string;frames:any[];[key:string]:any}>; path?:string };
let indexPromise:Promise<Record<string,string>>|undefined;
export function supportsLosslessWebP():Promise<boolean> {
  return new Promise(resolve=>{
    const image=new Image();let done=false;
    const finish=(valid:boolean)=>{if(done)return;done=true;window.clearTimeout(timer);image.onload=image.onerror=null;resolve(valid);};
    const timer=window.setTimeout(()=>finish(false),2000);
    image.onload=()=>finish(image.width===1&&image.height===1);image.onerror=()=>finish(false);
    image.src='data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
  });
}
const json = async (url:string) => {
  const controller=new AbortController(),timer=window.setTimeout(()=>controller.abort(),15000);
  try {const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw Error('Mobile atlas unavailable');return await response.json();}
  finally {window.clearTimeout(timer);}
};

export function selectMobileAtlas(atlas:MobileAtlas, animations?:Set<string>):MobileAtlas {
  if(!animations)return atlas;
  const textures=atlas.textures.filter(page=>!page.animation||page.animation==='*'||animations.has(page.animation));
  return {...atlas,textures:textures.length?textures:atlas.textures};
}

/** Fetch only JSON here. Small PNG pages are queued by Phaser afterwards. */
export async function prepareMobileBattleAssets(paths:string[]):Promise<Map<string,MobileAtlas>> {
  const result=new Map<string,MobileAtlas>();
  if(!isMobileGameDevice())return result;
  const base=process.env.REACT_APP_CDN_PATH??'';
  try {
    if(!indexPromise)indexPromise=supportsLosslessWebP().then(webp=>webp?json(`${base}mobile-combat-v3/index.json?revision=${Date.now()}`):{}).catch(error=>{indexPromise=undefined;throw error;});
    const index=await indexPromise;
    const queue=Array.from(new Set(paths)).filter(path=>index[path]);
    // Bound concurrent requests so slow mobile connections are not flooded.
    let cursor=0;
    await Promise.all(Array.from({length:Math.min(4,queue.length)},async()=>{
      while(cursor<queue.length){const path=queue[cursor++],url=index[path];
        try{const atlas=await json(base+url);if(Array.isArray(atlas.textures))result.set(path,{...atlas,path:new URL(base+url.substring(0,url.lastIndexOf('/')+1),window.location.href).href});}catch{/* Existing assets remain the fallback for unavailable metadata. */}
      }
    }));
  } catch {/* Allow older asset servers to keep their normal loader. */}
  return result;
}
